import * as React from 'react';
import AppUtils from './utils/AppUtils';
import { db, auth } from './firebase/firebase';

import './App.css';
import './sass/ScoreContainer.css';
import ScoreUtils from './utils/ScoreUtils';
import Logo from './components/Logo';
import AppConfig from './config/AppConfig';
import StoryDiagram from './components/StoryDiagram';
import ScoreContainer from './components/ScoreContainer';
import LoadingOverlay from './components/LoadingOverlay';
import AnalyticsDashboardComponent from './components/analytics/AnalyticsDashboardComponent';
import SideNav from './components/SideNav';
import StoryTextComponent from './components/StoryTextComponent';
import StoryEditComponent from './components/storyEditComponent/StoryEditComponent';
// import UserNavMenu from './components/UserNavMenu';
import LeaderboardComponent from './components/LeaderboardComponent';
import SettingsComponent from './components/SettingsComponent';
import Story from './objects/Story';
import Chapter from './objects/Chapter';
import Analytics from './objects/Analytics';
import Settings from './objects/Settings';
import History from './objects/History';
import States from './objects/States';
import Decision from './objects/Decision';
// import PageEditComponent from './components/PageEditComponent';

// import './sass/Incognito.css';

const _global = (window) as any;

class Base extends React.Component<any, any> {

  private chaptersDatabaseRef:firebase.database.Reference = db.app.database().ref('chapters');
  private appDatabaseRef:firebase.database.Reference = db.app.database().ref('appData');
  private userDatabaseRef:firebase.database.Reference = db.app.database().ref("users").child(auth.currentUser.uid);
  private leaderboardDatabaseRef:firebase.database.Reference = db.app.database().ref('leaderboard');
  private analyticsDatabaseRef:firebase.database.Reference = db.app.database().ref('analytics');
  private textDatabaseRef:firebase.database.Reference = db.app.database().ref('text');
  private settingsDatabaseRef:firebase.database.Reference = db.app.database().ref('settings');
  private loadingStage:number = 1;

  constructor(props:any) {
    super(props);

    AppUtils.isMobile = window.innerWidth <= AppConfig.MOBILE_WIDTH;
    ScoreUtils.resetTotals();

    this.state = {
      chapters: [new Chapter()],
      playerChapterData: [new Chapter()],
      text: AppConfig.text,
      settings: new Settings(),
      analytics: [{
        id: 1,
      }],
      gameStarted: false,
      leaderboardData: [],
      currentChapter: 0, // This is the index of the chapter! Not the ID!!
      loadingProgress: 0,
      width: window.innerWidth,
      isNewChapter: false,
      isDead: false,
      gameEnded: false,
      loaded: false,
      storyRefInt: 2,
      activeKey: "1", // This is the index of the story! Not the ID!!
      isGameVisible: true,
      isDataPanelVisible: false,
      isStoryEditorVisible: false,
      isSettingsVisible: false,
      isStoryViewPanelVisible: false,
      isLeaderboardVisible: false,
      decisionCooldown: false,
      storyPanelSelectedStoryID: 1,
      opened: true,
      characterReady: true,
      userData: {
        progress: 0,
        highscore: 0,
        score: 0,
        stat: 0,
        positive: 0,
        negative: 0,
      },
    };
    
    this.onChaptersDatabaseUpdated = this.onChaptersDatabaseUpdated.bind(this);
    this.onAppDatabaseUpdated = this.onAppDatabaseUpdated.bind(this);
    this.onLeaderboardDatabaseUpdated = this.onLeaderboardDatabaseUpdated.bind(this);
    this.onUserDatabaseUpdated = this.onUserDatabaseUpdated.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.jumpToStory = this.jumpToStory.bind(this);
    this.onStoryUpdated = this.onStoryUpdated.bind(this);
    this.onChapterUpdated = this.onChapterUpdated.bind(this);
    // this.storyPanelSelected = this.storyPanelSelected.bind(this);
    this.setCharacterReady = this.setCharacterReady.bind(this);
    this.toggleStoryViewPanel = this.toggleStoryViewPanel.bind(this);
    this.onAddNewPage = this.onAddNewPage.bind(this);
    this.onAddNewChapter = this.onAddNewChapter.bind(this);
    this.toggleStoryEditor = this.toggleStoryEditor.bind(this);
    this.toggleDataPanel = this.toggleDataPanel.bind(this);
    this.newChapterBegun = this.newChapterBegun.bind(this);
    this.changeChapter = this.changeChapter.bind(this);
    this.restartGame = this.restartGame.bind(this);
    this.preloadGame = this.preloadGame.bind(this);
    this.onTextLoaded = this.onTextLoaded.bind(this);
    this.onSettingsUpdated = this.onSettingsUpdated.bind(this);
    this.toggleSettings = this.toggleSettings.bind(this);

    // const _global = (window) as any
    _global.setCharacterReady = this.setCharacterReady

    // console.log("Preload ready: ",_global.preloadGame);
    //console.log(auth.currentUser);
  }

  componentDidMount() {
    this.loadPlatform()
  }

  componentWillUnmount() {
    if (this.chaptersDatabaseRef != null) {
      this.chaptersDatabaseRef.off();
      this.appDatabaseRef.off();
      this.userDatabaseRef.off();
      this.leaderboardDatabaseRef.off();
      this.analyticsDatabaseRef.off();
      this.textDatabaseRef.off();
      this.settingsDatabaseRef.off();
    }
  }

  private loadPlatform():void {
    if (this.state.loaded == true) { return };
    console.log("Loading stage: ", this.loadingStage)
    switch (this.loadingStage) {
      case 1:
        this.loadingStage += 1;
        this.settingsDatabaseRef.on('value', this.onSettingsUpdated);
        break;
      case 2:
        this.loadingStage += 1;
        this.preloadGame();
        this.setState({loadingProgress:15});
        break;
      case 3:
        this.loadingStage += 1;
        this.appDatabaseRef.on('value', this.onAppDatabaseUpdated);
        this.setState({loadingProgress:30});
        break;
      case 4:
        this.loadingStage += 1;
        this.setState({loadingProgress:45});
        this.userDatabaseRef.on('value', this.onUserDatabaseUpdated);
        break;
      case 5:
        this.loadingStage += 1;
        this.setState({loadingProgress:60});
        this.leaderboardDatabaseRef.on('value', this.onLeaderboardDatabaseUpdated);
        break;
      case 6:
          this.loadingStage += 1;
        this.setState({loadingProgress:75});
        this.textDatabaseRef.on('value', this.onTextLoaded);
        break;
      case 7:
        this.loadingStage += 1;
        this.setState({loadingProgress:90});
        if (this.state.userData.admin) {
          this.chaptersDatabaseRef.on('value', this.onChaptersDatabaseUpdated);
        } else {
          this.chaptersDatabaseRef.once('value', this.onChaptersDatabaseUpdated);
        }
        break;
      case 8:
        this.loadingStage += 1;
        this.analyticsDatabaseRef.child(this.state.chapters[0].id).set(this.createNewChapterAnalyticsNode(this.state.chapters[0])) // set up analytics for your first chapter
        this.setState({loaded:true, loadingProgress:100});
      default:
        break;
    }
  }

  private preloadGame():void {
    if (AppConfig.gameLoaded == false) {
      if (_global.preloadGame != null) {
        AppConfig.gameLoaded = true;
        console.log("[Base] Loading theme:", this.state.settings.theme)
        this.loadPlatform();
        _global.preloadGame(this.state.settings.theme);
      } else {
        setTimeout(this.preloadGame, 500);
      }
    } else {
      this.loadPlatform();
    }
  }

  public refs: {
    storyDiagram: StoryDiagram;
  };

  private restartGame():void {
    console.log("Restarting game:", this.state.settings.theme);
    this.clearUserProgress();
    ScoreUtils.resetTotals();
    db.app.database().ref('chapters').once('value').then((snapshot) => {
      this.setState({
        currentChapter: 0, // This is the index of the chapter! Not the ID!!
        playerChapterData: snapshot.val(),
        isNewChapter: false,
        gameEnded: false,
        activeKey: "1",
        isDead: false,
        storyPanelSelectedStoryID: 1,
        characterReady: true,
        gameStarted: false,
      });
      _global.reset(this.state.settings.theme);
    });
    
  }

  private setCharacterReady(isReady:Boolean):void {
    if (isReady != this.state.characterReady) {
      this.setState({characterReady: isReady});
    }
  }

  private changeChapter(chapterIndex:number):void {
    console.log("Changing chapter: ", chapterIndex)
    this.setState({currentChapter: chapterIndex})
  }

  // private getLocalStorys():any {
  //   let storys:Array<Story> = this.state.playerChapterData[this.state.currentChapter].storys;
  //   console.log("> getLocalStorys()", storys, this.state.chapters[this.state.currentChapter].storys)
  //   return storys;
  // }

  private createNewChapter(refInt:number):any {
    let chapter:Chapter = new Chapter();
    chapter.id = refInt;
    return chapter;
  }

  private createNewStory(storyRefInt:number, pageText?:string, decisons?:Array<Decision>):any {
    let story:Story = new Story();
    story.id = storyRefInt;
    story.text = pageText;
    story.textDecoded = pageText;
    if (decisons != null) {
      story.decisions = decisons;
    }
    return story;
  }

  private createNewChapterAnalyticsNode(newChapter:any):any {
    let analytics:Analytics = new Analytics();
    analytics.name = newChapter.name;
    return analytics;
  }

  private incrementAnalyticsStat(outcome:string, stat:string) {
    let chapterID:number = this.state.chapters[this.state.currentChapter].id;
    // console.log("Updating stat: ", outcome, stat, this.state.chapters[this.state.currentChapter].storys[this.state.activeKey - 1].tags, this.state.activeKey)
    let ref = this.analyticsDatabaseRef.child(chapterID.toString()).child(outcome.toLowerCase() + stat);
    ref.transaction(function(currentStat) {
      return (currentStat || 0) + 1;
    });
    if (stat.toLowerCase() == "total" && (outcome.toLowerCase() == "positive" || outcome.toLowerCase() == "negative")) {
      let tags = this.state.chapters[this.state.currentChapter].storys[this.state.activeKey - 1].tags;
      if (tags != null) {
        tags.forEach(tag => {
          let tagRef = this.analyticsDatabaseRef.child(chapterID.toString()).child("tags").child(tag.id);
          tagRef.child(outcome.toLowerCase() + stat).transaction(function(currentStat) {
            return (currentStat || 0) + 1;
          });
        });
      }
    }
  }

  private onAddNewPage(pageText?:string, decisions?:Array<Decision>, position?:number) {
    // this.toggleStoryEditPanel(false)
    let chapters:Array<Chapter> = this.state.chapters;
    //let storys  = chapters[this.state.currentChapter].storys;
    let storyRefInt = parseInt(this.state.storyRefInt) + 1;
    if (position != null) {
      chapters[this.state.currentChapter].storys.splice(position, 0, this.createNewStory(storyRefInt, pageText, decisions));
    } else {
      chapters[this.state.currentChapter].storys.push(this.createNewStory(storyRefInt, pageText, decisions));
    }
    this.setState({chapters: chapters, activeKey:storyRefInt.toString(), storyRefInt: storyRefInt});
    this.updateChaptersData(chapters);
    this.updateAppData(storyRefInt);
  }

  private onAddNewChapter() {
    let chapters = this.state.chapters;
    let refInt = parseInt(this.state.storyRefInt) + 1;
    let newChapter = this.createNewChapter(refInt)
    chapters.push(newChapter)
    this.analyticsDatabaseRef.child(newChapter.id).set(this.createNewChapterAnalyticsNode(newChapter))
    this.setState({chapters: chapters, activeKey:refInt.toString(), storyRefInt: refInt});
    this.updateChaptersData(chapters, true);
    this.updateAppData(refInt);
  }

  updateUserData(data:any) {this.userDatabaseRef.set(data);}
  updateAppData(data:number) {this.appDatabaseRef.set(data);}
  updateLeaderboardData(data:any) {this.leaderboardDatabaseRef.set(data);}
  updateChaptersData(data:any, shouldRefreshChapter?:boolean) {
    console.log("Updating the chapter data")
    if (shouldRefreshChapter) {
      this.chaptersDatabaseRef.set(data, this.refreshCurrentChapter.bind(this))
    } else {
      this.chaptersDatabaseRef.set(data)
    }
  }

  refreshCurrentChapter() {
    this.changeChapter(this.state.chapters.length-1)
  }

  private onSettingsUpdated(e:any):void {
    if (e.val() == null) {
      this.settingsDatabaseRef.set(new Settings());
    } else {
      this.setState({settings: {...this.state.settings, ...e.val()}})
    }

    if (this.state.loaded == false) {
      this.loadPlatform();
    }
  }

  private onAppDatabaseUpdated(e:any) {
    let storyRefInt:number = e.val();
    if (this.state.loaded == false && storyRefInt != null) {
      this.setState({storyRefInt: storyRefInt.toString()});
    }
    if (this.state.loaded == false) {
      this.loadPlatform();
    }
  }

  private onUserDatabaseUpdated(e:any) {
    console.log("Loaded: User database")
    // console.log(e.val());
    let userData:any = e.val();
    if (this.state.loaded == false && userData != null) {
      // this.userDataLoaded = true;
      let analytics = {
        n: 0, // negitive decisions
        p: 0, // positive decisions
        u: 0, // uplift
        g: 0, // gameplays
        d: 0, // decisions
        c: 0, // completitons
        e: 0, // died / ended
      };

      let settings:Settings = this.state.settings;

      if (!userData.highscore) {userData.highscore = 0}; // only the best score is stored
      if (!userData.score) {userData.score = 0}; // only the best score is stored
      if (!userData.stat) {userData.stat = settings.startingStat}; // not sure if this is needed yet?
      if (!userData.path) {userData.path = []};
      if (!userData.analytics) {userData.analytics = JSON.stringify(analytics)};
      if (!userData.progress) {userData.progress = 0};

      // reset data on refresh - TODO: Allow players to save their progress 
      // userData.efficiency = efficiency
      userData.score = 0;
      userData.stat = settings.startingStat;
      userData.path = [];
      userData.progress = 0; 
      userData.positive = 0; 
      userData.negative = 0; 

      this.setState({userData: userData});
    }
    if (this.state.loaded == false) {
      this.loadPlatform();
    }
  }

  private onLeaderboardDatabaseUpdated(e:any):void {
    console.log("Loaded: Leaderboard database")
    let data:any = e.val();
    if (data == null) {
      console.log("NO DATA")
      //this.updateLeaderboardData(this.state.leaderboardData);
      this.updateUserScore();
    } else {
      this.setState({leaderboardData: data});
    }
    
    // if (this.state.loaded == false && data != null) {
    //   if (!data.uid) {data.uid = this.state.userData.auth.currentUser.uid};
    //   if (!data.name) {data.name = 0};
    //   if (!data.score) {data.score = 0};
    //   this.setState({scoreboardData: data});
    // }
    if (this.state.loaded == false) {
      this.loadPlatform();
    }
  }

  private onTextLoaded(e:any):void {
    // console.log("Text:", e.val());
    if (e.val() == null) {
      // set default
      this.textDatabaseRef.set(AppConfig.text)
      this.setState({text: AppConfig.text});
    } else {
      this.setState({text: e.val()});
    }

    if (this.state.loaded == false) {
      this.loadPlatform();
    }
  }

  private updateUserScore():void {
    console.log("Updating the user score")
    let userLeaderboardData = {
      name: this.state.userData.firstName + " " + this.state.userData.lastName,
      score: this.state.userData.highscore * -1, // Invert the number. This get's turned back into a positive inside Leaderboard.brs. Seems like this is the only way to pull top 10 scores from firebase
    }
    let userLeaderboardDatabaseRef:firebase.database.Reference = db.app.database().ref('leaderboard').child(auth.currentUser.uid);
    userLeaderboardDatabaseRef.set(userLeaderboardData)
  }

  private onChaptersDatabaseUpdated(e:any):void {
    console.log("Loaded: chapter database")
    let chapters:Array<Chapter> = e.val();
    if (this.state.loaded == false && chapters != null && chapters != this.state.chapters) {
      History.jumpHistory.push({jumpChapterIndex: 0, jumpPage: chapters[0].storys[0].id.toString()})
      if (_global.updateProgress) {
        _global.updateProgress(this.state.userData.progress+1);
      }
      this.setState({chapters: chapters, playerChapterData:e.val(), loaded:true});
    } else if (this.state.loaded == false && chapters == null) {
      this.loadPlatform();
    } else if (this.state.loaded == true && chapters != this.state.chapters) {
      console.log("Chapter data updated from another device")
      this.setState({chapters: chapters, playerChapterData:e.val()});
    } else if (this.state.loaded == true && this.state.chapters != this.state.playerChapterData) {
      // reload the local chapter data for the player
      console.log("Updateing player chapter data");
      this.setState({playerChapterData:e.val()});
    }
  }

  private onStoryUpdated(storys:Array<Story>, shouldUpdate:boolean = true) {
    let chapters:Array<Chapter> = this.state.chapters;
    chapters[this.state.currentChapter].storys = storys;
    this.onChapterUpdated(chapters, shouldUpdate)
  }

  private onChapterUpdated(chapters:Array<Chapter>, shouldUpdate:boolean = true, closeStoryEditPanel = false) {
    if (shouldUpdate) {
      this.updateChaptersData(chapters);
    } else {
      this.setState({chapters: chapters});
    }
  }

  private newChapterBegun():void {
    this.setState({isNewChapter: false});
  }

  private clearUserProgress():void {
    let settings:Settings = this.state.settings;
    let userData = this.state.userData;
    userData.score = 0;
    userData.stat = this.state.settings.startingStat;
    userData.path = [];
    userData.progress = 1;
    userData.positive = 0;
    userData.negative = 0;
    this.setState({userData: userData});
    this.updateUserData(userData);
  }

  private jumpToStory(jumpPage:string, outcome:string, impact:string, move:string, jumpChapterId:number, speedBonus:number, link:string) {
    let jumpChapterIndex:number = AppUtils.getChapterIndex(this.state, jumpChapterId.toString());
    // console.log("jumpToStory",jumpPage, jumpChapterId, jumpChapterIndex)
    if (jumpPage == States.link) {
      window.open(link)
      return;
    }
    if (jumpPage == States.backAStep) {
      History.jumpHistory.pop()
      jumpPage = History.jumpHistory[History.jumpHistory.length-1].jumpPage;
      jumpChapterId = History.jumpHistory[History.jumpHistory.length-1].jumpChapterIndex;
    } else {
      History.jumpHistory.push({jumpChapterIndex: jumpChapterIndex, jumpPage: jumpPage})
    }
    
    if (jumpPage == States.gameOverSuccess) {
      outcome = "Positive"
      this.updateGame(jumpPage, outcome, impact, move, this.state.currentChapter, false, true, speedBonus);
      return;
    }
    if (jumpPage == States.gameOverFail) {
      outcome = "Negative"
      let playerDead:boolean = true;
      this.updateGame(jumpPage, outcome, impact, move, this.state.currentChapter, false, true, speedBonus, playerDead);
      return;
    }
    if (jumpPage == States.restart) {
      this.restartGame()
      return;
    }
    let jumpIndex:number;
    let isNewChapter:boolean = false;
    if(jumpChapterIndex != this.state.currentChapter && this.state.chapters[jumpChapterIndex] != null) {
      isNewChapter = true;
      outcome = "Positive"
      jumpIndex = AppUtils.findIndexByKey(this.state.chapters[jumpChapterIndex].storys, 'id', parseInt(jumpPage));
      this.setState({decisionCooldown:true, currentChapter: jumpChapterIndex, activeKey: (jumpIndex+1).toString()});
    } else {
      jumpIndex = AppUtils.findIndexByKey(this.state.chapters[this.state.currentChapter].storys, 'id', parseInt(jumpPage));
      this.setState({decisionCooldown:true, activeKey: (jumpIndex+1).toString()});
    }
    setTimeout(() => this.setState({decisionCooldown:false}), 200);
    this.updateGame(jumpPage, outcome, impact, move, jumpChapterIndex, isNewChapter, false, speedBonus);
  }

  private updateGame(jumpPage:string, outcome:string, impact:string, move:string, jumpChapterIndex:number, isNewChapter:boolean, isEnd:boolean, speedBonus:number, isDead:boolean = false) {
    console.log("Update game,", jumpPage, jumpChapterIndex)
    
    let userData:any = this.state.userData;
    let analytics:any = JSON.parse(userData.analytics);
    if (speedBonus == null || speedBonus == undefined) {
      speedBonus = 0;
    }
    if (outcome == "Positive" || outcome == "Negative") {
      if (impact == "None") {
        impact = "Tiny";
      }
    }

    if (analytics == null) {
      analytics = {
        n: 0, // negitive decisions
        p: 0, // positive decisions
        u: 0, // uplift
        g: 0, // gameplays
        d: 0, // decisions
        c: 0, // completions
        e: 0, // died / ended
      };
    }

    //JSON.stringify(analytics)

    if (outcome != "Negative") {
      userData.score += ScoreUtils.BASE_SCORE; // add a base score provided the decision wasn't negative
      userData.score += speedBonus;
    }

    if (this.state.gameStarted == false) {
      analytics.g++
      this.incrementAnalyticsStat("started","")
    }

    let settings:Settings = this.state.settings;

    if (outcome == "Negative") {
      userData.stat -= ScoreUtils.getImpactScores(impact, this.state.settings).stat;
      ScoreUtils.gameNegativeTotals[impact.toLowerCase()] += 1;
      userData.negative++;
      analytics.n++
      this.incrementAnalyticsStat(outcome, impact)
      this.incrementAnalyticsStat("negative", "Total")
    } else if (outcome == "Positive") {
      userData.positive++;
      analytics.p++
      userData.score += ScoreUtils.getImpactScores(impact, this.state.settings).score; // add the positive decision bonus
      userData.stat += ScoreUtils.getImpactScores(impact, this.state.settings).stat;
      ScoreUtils.gamePositiveTotals[impact.toLowerCase()] += 1;
      if (userData.stat >= settings.maxStat) { userData.stat = settings.maxStat };
      this.incrementAnalyticsStat(outcome, impact)
      this.incrementAnalyticsStat("positive", "Total")
    }

    analytics.d++
    userData.progress++
    this.incrementAnalyticsStat("decisions", "")

    if (userData.stat <= settings.minStat) {
      isDead = true;
    }

    if (isDead || isEnd) {
      if (isDead) {analytics.e++; this.incrementAnalyticsStat("fails","")}
      if (isEnd) {analytics.c++; this.incrementAnalyticsStat("completed","")}
      if (userData.score > userData.highscore) {
        userData.highscore = userData.score
      }
    }

    let totalFinishes:number = analytics.e + analytics.c;

    if (totalFinishes > 1 && (isEnd || isDead)) {
      // player is playing again so now we check to see if they have improved
      if (userData.score > userData.highscore) {
        // there's been an improvement
        analytics.u = (userData.highscore / (userData.score - userData.highscore)) * 100; // improvement %
      }
    }

    userData.analytics = JSON.stringify(analytics);

    this.setState({gameStarted: true, userData: userData, isNewChapter: isNewChapter, gameEnded: isEnd, isDead: isDead});
    this.updateUserData(userData); // This will probably need to be called each update for tracking purposes
    this.updateUserScore(); // TODO: Only call this on gameover as we need to restrict the number of calls hitting the db
    _global.updateProgress(userData.progress+1, outcome, impact, move, isNewChapter, isDead, isEnd);
  }

  // private decisionCooldownComplete() {
  //   this.setState({decisionCooldown:false});
  // }

  private handleSelect(activeKey:any) {
    this.setState({ activeKey });
  }

  private toggleDataPanel(isVisible:boolean) {
    console.log("toggleDataPanel", isVisible)
    this.setState({isDataPanelVisible:isVisible})
  }

  private toggleStoryEditor(isVisible:boolean) {
    this.setState({isStoryEditorVisible:isVisible})
    if (isVisible == false) {
      // let localChapters:Array<Chapter> = new Array();
      // localChapters = this.state.chapters
      // this.setState({playerChapterData: localChapters});
      this.restartGame();
    }
  }

  private toggleStoryViewPanel(isVisible:boolean) {
    this.setState({isStoryViewPanelVisible:isVisible})
    if (isVisible == false) {
      this.setState({activeKey: "1", isStoryViewPanelVisible:isVisible, currentChapter:0, gameEnded:false})
      // this.updateChaptersData(this.state.chapters);
      // this.restartGame();
    }
  }

  // private toggleStoryEditPanel(isVisible:boolean) {
  //   if (isVisible == false && AppUtils.isMobile && this.state.isStoryEditPanelVisible == true) {
  //     console.log("hide edit panel")
  //     this.toggleStoryViewPanel(true);
  //     this.restartGame();
  //     this.setState({isStoryEditPanelVisible:isVisible})
  //   }

  // }

  private toggleLeaderboard(visible:boolean) {
    this.setState({isLeaderboardVisible: visible});
  }

  private toggleSettings(visible:boolean) {
    this.setState({isSettingsVisible: visible});
  }

  // private storyPanelSelected(storyId:any) {
  //   let activeNum:number = AppUtils.findIndexByKey(this.state.chapters[this.state.currentChapter].storys,"id",parseInt(storyId));
  //   let activeKey = (activeNum+1).toString();
  //   if (AppUtils.isMobile) {
  //     this.setState({activeKey: activeKey, isStoryEditPanelVisible: true, isStoryViewPanelVisible: false, storyPanelSelectedStoryID: storyId});
  //   } else {
  //     this.setState({activeKey: activeKey, isStoryEditPanelVisible: true, storyPanelSelectedStoryID: storyId});
  //   }
  // }

  private isGameInView():boolean {
    let isInView = true;
    if (this.state.isDataPanelVisible || this.state.isStoryEditorVisible || this.state.isLeaderboardVisible || this.state.isStoryViewPanelVisible) {
      isInView = false
    }
    return isInView
  }

  render() {
    return (
      <div>
        <SideNav userData={this.state.userData} loaded={this.state.loaded} toggleSettings={this.toggleSettings} toggleLeaderboard={this.toggleLeaderboard.bind(this)} toggleStoryEditPanel={this.toggleStoryEditor} toggleStoryViewPanel={this.toggleStoryViewPanel} toggleDataPanel={this.toggleDataPanel} />
        <div className='editPanelContainer'>
          <Logo />
          <LoadingOverlay showProgress={true} progress={this.state.loadingProgress} visible={!this.state.loaded} />
          <ScoreContainer chapters={this.state.chapters} currentChapter={this.state.currentChapter} settings={this.state.settings} loaded={this.state.loaded} userData={this.state.userData} />
          { this.isGameInView() && this.state.loaded == true && this.state.decisionCooldown == false ? <StoryTextComponent settings={this.state.settings} text={this.state.text} isDead={this.state.isDead} newChapterBegun={this.newChapterBegun} isNewChapter={this.state.isNewChapter} userData={this.state.userData} playerChapterData={this.state.playerChapterData} activeKey={this.state.activeKey} gameEnded={this.state.gameEnded} currentChapter={this.state.currentChapter} restartGame={this.restartGame} jumpToStory={this.jumpToStory} isStoryViewPanelVisible={this.state.isStoryViewPanelVisible} characterReady={this.state.characterReady} userDataProgress={this.state.userData.progress} loaded={this.state.loaded} leaderboardDatabaseRef={this.leaderboardDatabaseRef} /> : null }
          { this.state.isStoryViewPanelVisible ? <StoryDiagram currentChapter={this.state.currentChapter} chapters={this.state.chapters} userData={this.state.userData} isStoryViewPanelVisible={this.state.isStoryViewPanelVisible} storys={this.state.chapters[this.state.currentChapter].storys} ref="storyDiagram" /> : null }
          { this.state.isSettingsVisible ? <SettingsComponent settingsDatabaseRef={this.settingsDatabaseRef} textDatabaseRef={this.textDatabaseRef} settings={this.state.settings} text={this.state.text} userData={this.state.userData} isStoryViewPanelVisible={this.state.isStoryViewPanelVisible} /> : null }
          { this.state.isDataPanelVisible ? <AnalyticsDashboardComponent settings={this.state.settings} userDatabaseRef={this.userDatabaseRef} analyticsDatabaseRef={this.analyticsDatabaseRef} userData={this.state.userData} isVisible={this.state.isDataPanelVisible} /> : null }
          { this.state.isStoryEditorVisible ? <StoryEditComponent tags={this.state.settings.tags} analyticsDatabaseRef={this.analyticsDatabaseRef} onChapterUpdated={this.onChapterUpdated} onChapterChange={this.changeChapter} onStoryUpdated={this.onStoryUpdated} addNewPage={this.onAddNewPage} addNewChapter={this.onAddNewChapter} userData={this.state.userData} currentChapter={this.state.currentChapter} chapters={this.state.chapters} isVisible={this.state.isStoryEditorVisible} /> : null }
          { this.state.isLeaderboardVisible ? <LeaderboardComponent settings={this.state.settings} userData={this.state.userData} leaderboardDatabaseRef={this.leaderboardDatabaseRef}/> : null }
          {/* <UserNavMenu leaderboardDatabaseRef={this.leaderboardDatabaseRef} isPanelVisible={this.state.isLeaderboardVisible} toggleLeaderboard={this.toggleLeaderboard.bind(this)}/> */}
        </div> 
      </div>
    );
  }
}

export default Base;



// WEBPACK FOOTER //
// ./src/Base.tsx